<!-- <app-sidebar></app-sidebar> -->
<app-hire-sidebar></app-hire-sidebar>
<!-- <app-navbar></app-navbar> -->
<div class="row mb-3px">
  <div class="col  wccard pt-3 pb-0">
    <div class="row mb-2">
      <div class="col">
        <p class="f-14 mb-3 font-weight-500 mb-3 d-flex justify-content-between">Email Settings </p>
        <p class="mb-3  f-12 gray-text">Do you wish to send a warm and personalized acknowledgement email to every
          candidate who applies to your company? Email notifications help you customize (almost) every email that is
          sent from whitecrow to candiates, recruiters, interviewers etc</p>
      </div>
    </div>
    <div class="row mb-2">
      <div class="col">
        <p class="f-14 mb-3 font-weight-500  mb-3 d-flex justify-content-between">Custom Email Template </p>
      </div>
    </div>
  </div>
</div>

<div class="row mb-3px">
  <div class="col  wccard py-3 pb-0">
  <div class="d-flex mb-3 justify-content-between">
    <span class="gray-text font-weight-500">Templates</span>
    <span class="f-14 font-weight-600 text-blue pointer"><a data-testid="auto-app-email-template-a-1" (click)="openEmailCustomModal()">+ ADD NEW</a></span>
  </div>
  <div class="row onHover" *ngFor = "let email of customtemp">
    <div class="col d-flex py-3 pointer">
      <div class="position-relative w-100">
          <span class="font-weight-500 emailtemplate"> {{email.actionname}}</span>
          <div class="mt-1">
            <span class="gray-text font-weight-500 mr-4 f-12" *ngIf="email.createdon==email.updatedon"> CreatedOn : {{email.updatedon | date :'short'}}
            </span>
            <span class="gray-text font-weight-500 mr-4 f-12" *ngIf="email.createdon!=email.updatedon && email.subtype != 'default'"> UpdatedOn : {{email.updatedon | date :'short'}}
            </span>
            <span class="gray-text font-weight-500 f-12" *ngIf="email.subtype != 'default'">Created by : {{email.loginfirstname}} {{email.loginlastname}} </span>
            <span class="gray-text font-weight-500 f-12" *ngIf="email.subtype == 'default'">Created by : System </span>
          </div>
        <div class="position-absolute tr0 onhverEdit">
          <span class="mx-2 ats-cta-btn f-12" *ngIf="email.subtype != 'default'" >
            <i class="fas fa-edit" (click)="openEmailCustomModal(email)" ></i>
          </span>
            <span class="mx-1 ats-cta-btn" *ngIf="email.subtype != 'default'">
              <i class="fas fa-trash" (click)="deleteCustomModal(email)"></i>
            </span>
            <a data-testid="auto-app-email-template-a-2" (click)="openPreviewEmailTemplateModal(email)"  *ngIf="email.subtype == 'default'">
              <span class="mx-2 ats-cta-btn">
                <i class="fas fa-eye"></i>
              </span>
            </a>
        </div>
      </div>
    </div>
  </div>
</div>
</div>


<ng-template #deleteCustomTempalte>
  <div class="modal-header b pb-0">
    <h5 class="modal-title" id="experience"></h5>
    <button data-testid="auto-app-email-template-button-1" type="button" class="close font-weight-normal" data-dismiss="modal" aria-label="Close" (click)="modalService.dismissAll()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body pb-6">
    <div class="row mb-6">
      <div class="col text-center">
        <p>Are you sure to delete this?<p>
      </div>
    </div>
    <div class="row mb-3">
        <div class="col-md-10 mx-auto d-flex">
          <button data-testid="auto-app-email-template-button-2" class="btn-trms-white mx-auto" (click)="modalService.dismissAll()">NO</button>
          <button data-testid="auto-app-email-template-button-3" class="btn-trms-small m-auto"  (click)="deletecustom()">YES</button>
        </div>
      </div>
  </div>
</ng-template>

<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success"  (close)="successMessage = ''" >
  <span class="successCheck"><i class="fal fa-check"></i> </span>
 <span class="successmsg">{{ successMessage }}</span>
</ngb-alert>

<ngb-alert class="ngb-alert" *ngIf="errorMessage"   type="danger"  (close)="errorMessage = ''">
 <span class="errorCheck"><i class="fal fa-times"></i></span>
 <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>


<ng-template #previewemail>
  <div class="modal-header b px-5">
    <h6 class="modal-title text-uppercase font-weight-600 text-defualt"> Email Template Preview</h6>
    <span type="button" class="close font-weight-normal f-16 ms-auto" data-bs-dismiss="modal" aria-bs-label="Close"
    (click)="modalService.dismissAll()">
   <i class="fas fa-times f-14 text-black"></i>
</span>
  </div>
  <div class="modal-body pt-0 px-5">
    <div class="form-group mb-0">
      <div class="row mb-3">
        <div class="col">
          <p class="f-12 mb-2">Email Template</p>
          <p class="">{{pactionname}} </p>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col">
          <p class="f-12">Subject</p>
          <p class="">{{psubject}} </p>
        </div>
      </div>

      <div class="row mb-6">
        <div class="col-md-8">
          <div class="position-relative">
            <p class="" [innerHtml]="ptemplate"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
